import { Box, Grid, HStack, Icon, Link, Stack, StackDivider, Text, Tooltip, VStack } from '@chakra-ui/react';
import React from 'react';
import CopyableText from '@components/CopyableText';
import genericCardFactory from '@components/GenericCard/genericCardFactory';
import { MdInfoOutline, MdOutlineOpenInNew } from 'react-icons/md';
import { Link as ReactLink } from 'react-router-dom';

/* Generic Card component to build Reusable Cards */
const GenericCard = ({
  cardData,
  cardType,
  maxW,
  ActionButtons, //list of button components
  selected = false,
  ...props
}) => {
  const {
    header,
    headerGridTemplateColumns,
    content,
    contentGridTemplateColumns
  } = genericCardFactory({ cardData, cardType, ...props });
  return (
    <Box position={'relative'} w={{ base: '100%', md: '100%' }} maxW={maxW || '850px'}>
      {selected && (
        <Box
          position="absolute"
          top={0}
          left={0}
          height="100%"
          width="1.5"
          bg="green.400"
        />
      )}
      <VStack
        bg="backGround"
        borderRadius="12px"
        divider={
          <StackDivider style={{ margin: '0' }} borderColor="whiteAlpha.300" />
        }
      >
        <Grid
          gridTemplateColumns={
            headerGridTemplateColumns
              ? headerGridTemplateColumns
              : {
                  base: 'repeat(2, auto)',
                  md: `repeat(${header?.length}, auto)`
                }
          }
          rowGap={2}
          w={'90%'}
          justifyContent="space-between"
          m={'1rem'}
        >
          {header.length > 0 && header?.map((field, i) => {
            const IconComponent = field.icon;
            return (
            <HStack key={i} spacing={1}>
              {IconComponent && (
                <IconComponent size="1rem" color="gray" />
              )}
              <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
                {field.name}
                {field.name?.length ? ':' : ''}
              </Text>
              {field.isPopup ? (
                <MdOutlineOpenInNew
                  color={'gray'}
                  cursor={'pointer'}
                  onClick={field.onClick}
                />
              ) : field.isCopyable ? (
                <CopyableText
                  title={field.name}
                  fontSize={{ base: 'sm', sm: 'md' }}
                  color="white"
                >
                  {field.value}
                </CopyableText>
              ) : field.value?.color ? (
                <HStack spacing={2}>
                  <Box
                    w="8px"
                    h="8px"
                    borderRadius="full"
                    bg={field.value.color}
                  />
                  <Text fontSize="sm">{field.value.text}</Text>
                </HStack>
              ) : (
                <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
                  {field.value}
                </Text>
              )}
              {field.tooltip && (
                <Tooltip
                  label={
                    <Box p={1}>
                      {field.tooltip.userFulfillmentStatus && (
                        <>
                          <Text fontWeight="bold" mb={1}>User Fulfillment Status:</Text>
                          <Text mb={2}>{field.tooltip.userFulfillmentStatus}</Text>
                        </>
                      )}
                      {field.tooltip.meaning && (
                        <>
                          <Text fontWeight="bold" mb={1}>Meaning:</Text>
                          <Text mb={2}>{field.tooltip.meaning}</Text>
                        </>
                      )}
                      {field.tooltip.action && (
                        <>
                          <Text fontWeight="bold" mb={1}>Action:</Text>
                          <Text>{field.tooltip.action}</Text>
                        </>
                      )}
                    </Box>
                  }
                  placement="top"
                  hasArrow
                  bg="gray.700"
                  color="white"
                  borderRadius="md"
                  maxW="300px"
                >
                  <Box as="span" cursor="pointer" display="inline-flex" alignItems="center">
                    <Icon as={MdInfoOutline} color="gray.400" _hover={{ color: 'white' }} />
                  </Box>
                </Tooltip>
              )}
            </HStack>
            );
          })}
        </Grid>
        <Grid
          gridTemplateColumns={{
            base: '1fr',
            md: contentGridTemplateColumns
              ? contentGridTemplateColumns
              : `${content?.map((field) => '1fr ')} ${ActionButtons?.map(
                  (actionButton) => 'auto '
                )}`.replaceAll(',', '')
          }}
          gap={2}
          alignItems={'flex-start'}
          w={'90%'}
          m={'1rem'}
          textAlign={{ base: 'end', md: 'start' }}
        >
          {content.length > 0 && content?.map((field, i) => {
            const IconComponent = field.icon;
            return (
            <Stack
              key={i}
              direction={{ base: 'row', md: 'column' }}
              justifyContent={'space-between'}
            >
              <HStack spacing={1}>
                {IconComponent && (
                  <IconComponent size="0.9rem" color="gray" />
                )}
                <Text fontSize={'sm'} color={'gray'}>
                  {field.name}
                  {field.name?.length ? ':' : ''}
                </Text>
              </HStack>
              {!field?.value?.length ? (
                <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
                  -
                </Text>
              ) : field.isLink && field.value !== '-' ? (
                <Link
                  as={ReactLink}
                  to={field.route}
                  color="white"
                  _hover={{
                    textDecor: 'underline'
                  }}
                  fontSize={'sm'}
                >
                  <HStack>
                    <Text>{field.value}</Text>
                  </HStack>
                </Link>
              ) : field.isPopup ? (
                <MdOutlineOpenInNew
                  color={'gray'}
                  cursor={'pointer'}
                  onClick={field.onClick}
                />
              ) : field.isCopyable ? (
                <CopyableText
                  title={field.name}
                  fontSize={{ base: 'sm', sm: 'sm' }}
                  color="white"
                >
                  {field.value}
                </CopyableText>
              ) : (
                <Text fontSize={{ base: 'sm', sm: 'sm' }} color="white">
                  {field.value}
                </Text>
              )}
            </Stack>
            );
          })}
          {ActionButtons}
        </Grid>
      </VStack>
    </Box>
  );
};

export default GenericCard;
